<template>
<b-modal v-model="visible" size="lg" title="Address Verification" hide-footer no-close-on-backdrop>
    <p>The shipping address was modified during USPS validation. Please review the changes below.</p>

    <b-row>
        <b-col cols="6">
            <h6>Original Address</h6>
            <div class="address-card p-3 border rounded">
                <div :class="{ 'text-danger font-weight-bold': fieldChanged('addressLine1') }">
                    {{ originalAddress?.addressLine1 || '—' }}
                </div>
                <div :class="{ 'text-danger font-weight-bold': fieldChanged('addressLine2') }">
                    {{ originalAddress?.addressLine2 || '—' }}
                </div>
                <div>
                    <span :class="{ 'text-danger font-weight-bold': fieldChanged('city') }">
                        {{ originalAddress?.city || '—' }}
                    </span>,
                    <span :class="{ 'text-danger font-weight-bold': fieldChanged('state') }">
                        {{ originalAddress?.state || '—' }}
                    </span>
                    <span :class="{ 'text-danger font-weight-bold': fieldChanged('postalCode') }">
                        {{ originalAddress?.postalCode || '—' }}
                    </span>
                </div>
            </div>
        </b-col>

        <b-col cols="6">
            <h6>Suggested Address (USPS)</h6>
            <div class="address-card p-3 border rounded bg-light">
                <div :class="{ 'text-success font-weight-bold': fieldChanged('addressLine1') }">
                    {{ normalizedAddress?.addressLine1 || '—' }}
                </div>
                <div :class="{ 'text-success font-weight-bold': fieldChanged('addressLine2') }">
                    {{ normalizedAddress?.addressLine2 || '—' }}
                </div>
                <div>
                    <span :class="{ 'text-success font-weight-bold': fieldChanged('city') }">
                        {{ normalizedAddress?.city || '—' }}
                    </span>,
                    <span :class="{ 'text-success font-weight-bold': fieldChanged('state') }">
                        {{ normalizedAddress?.state || '—' }}
                    </span>
                    <span :class="{ 'text-success font-weight-bold': fieldChanged('postalCode') }">
                        {{ normalizedAddress?.postalCode || '—' }}
                    </span>
                </div>
            </div>
        </b-col>
    </b-row>

    <b-row class="mt-3">
        <b-col class="d-flex justify-content-end" style="gap: 8px;">
            <b-button variant="outline-secondary" @click="cancel">Cancel</b-button>
            <b-button variant="warning" @click="keepOriginal">Keep Original</b-button>
            <b-button variant="primary" @click="useSuggested">Use Suggested Address</b-button>
        </b-col>
    </b-row>
</b-modal>
</template>

<script lang="ts">
import { Component, Prop, VModel, Vue } from "vue-property-decorator";
import { AddressDetail } from "@/models/AddressValidation";

@Component({ name: "AddressApprovalModal" })
export default class AddressApprovalModal extends Vue {
    @VModel({ type: Boolean, default: false }) visible!: boolean;
    @Prop() originalAddress!: AddressDetail | null;
    @Prop() normalizedAddress!: AddressDetail | null;

    fieldChanged(field: keyof AddressDetail): boolean {
        const original = (this.originalAddress?.[field] ?? '').toString().trim().toLowerCase();
        const normalized = (this.normalizedAddress?.[field] ?? '').toString().trim().toLowerCase();
        return original !== normalized;
    }

    useSuggested() {
        this.visible = false;
        this.$emit('approve');
    }

    keepOriginal() {
        this.visible = false;
        this.$emit('override');
    }

    cancel() {
        this.visible = false;
    }
}
</script>
